import {createActions} from 'redux-actions';
import fetchJson from '../fetchJson';
import handleError from '../handleError';

const actions = createActions('CATEGORIES_PROVIDER_LOADED', 'CATEGORIES_COMMUNITY_LOADED');

export const retrieveCategories = () => dispatch => {
	fetchJson('/api/category/provider/')
		.then(categories => dispatch(actions.categoriesProviderLoaded(categories)))
		.catch(handleError(dispatch));

	fetchJson('/api/category/community/')
		.then(categories => dispatch(actions.categoriesCommunityLoaded(categories)))
		.catch(handleError(dispatch));
};

export default {
	...actions,
	retrieveCategories
};



// WEBPACK FOOTER //
// ./src/category/category.actions.js